import {AmplifyTheme, ForgotPassword} from "aws-amplify-react";
import Amplify, {Auth, I18n} from "aws-amplify";
import React from "react";
import axiosBase from "axios";
import APP_ENV from "../Environment";
import {ForgetPasswordComponent} from "../Components/ForgotPasswordComponents";
import TranslateError from "../translate/TranslateError";
import {FormField, Hint, Input, InputLabel} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import {STYLE_DISABLE_LINK, STYLE_LINK} from "../Styles/style";
import SimpleReactValidator from "simple-react-validator";
import {err_logger} from "../Logics/logger";

export default class MyForgotPassword extends ForgotPassword {

    handlePasswordChange(e) {
      this.setState({ password: e.target.value });
    }

    toggleShow() {
      this.setState({ hidden: !this.state.hidden });
    }

    componentDidMount() {
      if (this.props.password) {
        this.setState({ password: this.props.password });
      }
    }

    constructor() {
        super();
        this._validAuthStates = ['forgotPassword'];
        this.state = {
            isSendDisabled: false,
            isSubmitDisabled: false,
            resendCodeStyle : STYLE_LINK,
            code: "",
            password: "",
            confirm_password: "",
            isSetQueryParam: false,
            hidden: true
        }
        this.toggleShow = this.toggleShow.bind(this);
        this.handleInputChangeCustom = this.handleInputChangeCustom.bind(this);
        this.validator = new SimpleReactValidator(
            {
                className: 'text-danger',
                messages: {
                    required: "入力必須項目です ",
                    integer: 'メールアドレスに送られている数字6桁の認証コードを入力してください ',
                    between: 'メールアドレスに送られている数字6桁の認証コードを入力してください ',
                },
                validators: {
                    password_regex: {
                        message: 'パスワードは大文字英字A-Z、小文字英字a-z、数字0-9をそれぞれ1文字以上使用し、8文字以上で設定してください',
                        rule: (val, params, validator) => {
                            return validator.helpers.testRegex(val,/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,99}$/g)
                        }
                    }
                }
            }
        );

    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.authData && this.props.authData.code && !this.state.isSetQueryParam) {
            this.setState({
                code : this.props.authData.code,
                isSetQueryParam: true
            });
        }
    }
    handleInputChangeCustom (e) {
        this.setState({
            [e.target.name] : e.target.value
        });
    }
    validate() {
        let err  = "";
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            err = "入力誤りがあります。";
            this.forceUpdate();
        } else {
            if (this.state.password !== this.state.confirm_password) {
                err += "確認用のパスワードが違います ";
            }
        }
        return err;
    }

    sendView() {
        const theme = this.props.theme || AmplifyTheme;
        return (
            <div>
                <FormField theme={theme}>
                    <InputLabel theme={theme}>{I18n.get('Username')} *</InputLabel>
                    <Input
                        autoFocus
                        placeholder={I18n.get('Enter your username')}
                        theme={theme}
                        key="username"
                        name="username"
                        onChange={this.handleInputChange}
                    />
                </FormField>
            </div>
        );
    }
    submitView() {
        const theme = this.props.theme || AmplifyTheme;
        return (
            <div>
                <FormField theme={theme}>
                    <InputLabel theme={theme}>{I18n.get("Code")}</InputLabel>
                    <Hint theme={theme}>{I18n.get("Attention to enter authorization code")}</Hint>
                    {this.validator.message('code', this.state.code, 'required|integer|between:6,6')}
                    <Input
                        placeholder=""
                        theme={theme}
                        type="number"
                        key="code"
                        name="code"
                        value={this.state.code}
                        autoComplete="off"
                        onChange={this.handleInputChangeCustom}
                    />
                </FormField>
                <FormField theme={theme}>
                    <InputLabel theme={theme}>{I18n.get("Password")}</InputLabel>
                    <Hint theme={theme}>{I18n.get("Password must be at least 8 characters long upper case letters, lower case letters, half size numbers must be at least 1 character each")}</Hint>
                    {this.validator.message('password', this.state.password, 'required|password_regex')}
                    <Input
                        placeholder=""
                        theme={theme}
                        type={this.state.hidden ? "password" : "text"}
                        key="password"
                        name="password"
                        value={this.state.password}
                        onChange={this.handleInputChangeCustom}
                    />
                  <div className="switch_passhide"><label><input type="checkbox" onClick={this.toggleShow} />パスワードを表示する </label></div>
                </FormField>
                <FormField theme={theme}>
                    <InputLabel theme={theme}>{I18n.get("Confirm Password")}</InputLabel>
                    {this.validator.message('confirm_password', this.state.confirm_password, 'required')}
                    <Input
                        placeholder=""
                        theme={theme}
                        type="password"
                        key="confirm_password"
                        name="confirm_password"
                        value={this.state.confirm_password}
                        onChange={this.handleInputChangeCustom}
                    />
                </FormField>
                <Hint theme={theme}>{I18n.get("Password must be at least 8 characters long upper case letters, lower case letters, half size numbers must be at least 1 character each")}</Hint>
            </div>
        );
    }
    send() {
        this.setState({
            isSendDisabled: true,
            isSubmitDisabled: true,
            resendCodeStyle : STYLE_DISABLE_LINK
        });
        const { authData={} } = this.props;
        let username = this.inputs.username || authData.username;
        if (!username) {
            this.error("未入力の項目があります");
            this.setState({
                isSendDisabled: false,
                isSubmitDisabled: false,
                resendCodeStyle : STYLE_LINK
            });
            return;
        }
        username = username.toLowerCase();

        if (!Auth || typeof Auth.forgotPassword !== 'function') {
            this.setState({
                isSendDisabled: false,
                isSubmitDisabled: false,
                resendCodeStyle : STYLE_LINK
            });
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }
        Auth.forgotPassword(username)
            .then(data => {
                this.setState({ delivery: data.CodeDeliveryDetails });
                this.error("認証コードを送信しました")
            })
            .catch((e) => {
                err_logger(username, e, "forgotPassword",{username});
                this.error("入力したメールアドレスでの登録ユーザは存在しません")
            }).finally(() => {
                this.setState({
                    isSendDisabled: false,
                    isSubmitDisabled: false,
                    resendCodeStyle : STYLE_LINK
                });
        });
    }
    submit() {
        const err = this.validate();
        if (err !== "" ) {
            this.error(err);
            return;
        }
        this.setState({
            isSendDisabled: true,
            isSubmitDisabled: true,
            resendCodeStyle : STYLE_DISABLE_LINK
        });
        const { authData={} } = this.props;
        const { code, password } = this.state;
        let username = this.inputs.username || authData.username;
        username = username.toLowerCase();

        if (!Auth || typeof Auth.forgotPasswordSubmit !== 'function') {
            this.setState({
                isSendDisabled: false,
                isSubmitDisabled: false,
                resendCodeStyle : STYLE_LINK
            });
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }
        Auth.forgotPasswordSubmit(username, code, password)
            .then(data => {
                // ↓ update library
                // 疑似signIn
                Amplify.Auth.signIn(username, password)
                    .then((user) => {
                        const axios = axiosBase.create({
                            baseURL: APP_ENV.BFF,
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json',
                                'Authorization': `Bearer ${user.signInUserSession.idToken.jwtToken}`
                            },
                            responseType: 'json'
                        });
                        axios.put(APP_ENV.BFF + "/user", {
                            customer_id: user.signInUserSession.idToken.payload["custom:ecc_customer_id"],
                            password: password,
                            sub: 'no_coupler'})
                            .then(() => {
                                window.history.replaceState('','','/');
                                this.setState({ delivery: null });
                                // 更新成功画面を表示
                                this.changeState('CompChangePass', user);
                            })
                            .catch((e) => {
                                err_logger(username, err, "failure put password",{username});
                                this.error("パスワードの更新に失敗しました");
                            })
                            .finally(() => {
                                this.setState({
                                    isSendDisabled: false,
                                    isSubmitDisabled: false,
                                    resendCodeStyle : STYLE_LINK
                                });
                            });

                        // ↑ update library

            }).catch(err => {
                    err_logger(username, err, "signIn in confirm forgotPassword",{username});
                    this.setState({
                        isSendDisabled: false,
                        isSubmitDisabled: false,
                        resendCodeStyle : STYLE_LINK
                    });
                    this.error(TranslateError(err))
            });
        }).catch(err => {
            this.setState({
                isSendDisabled: false,
                isSubmitDisabled: false,
                resendCodeStyle : STYLE_LINK
            });
            err_logger(username, err, "confirm forgotPassword",{username, code});
            this.error(TranslateError(err))
        });
    }

    showComponent(theme) {
        const { authData={},authState } = this.props;
        const username = authState === "signedIn" ? "" : authData.username;
        return (
            <ForgetPasswordComponent theme={theme} delivery={this.state.delivery} username={username}
                                     myForgotPassword={this} submit={this.submit}
                                     isSendDisabled={this.state.isSendDisabled}
                                     isSubmitDisabled={this.state.isSubmitDisabled}
                                     resendCodeStyle={this.state.resendCodeStyle}
                                     changeStateFunc={() => {
                                         window.history.replaceState('','','/');
                                         this.changeState('signIn')
                                     }}/>
        );
    }
}
